
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { useEffect, useRef, useState } from 'react';
import { getRecruitmentInfoList } from '@/api/tms';

import imgLogo from '@/assets/images/logo/white-logo.png';
import {
  Alert,
  AlertTitle,
  Button,
  createTheme,
  Dialog,
  DialogActions,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Snackbar,
  ThemeProvider
} from '@mui/material';

// 创建主题
const theme = createTheme({
  components: {
    MuiFormControl: {
      styleOverrides: {
        root: {
          marginBottom: '16px'
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: 'rgba(0, 0, 0, 0.6)',
          '&.Mui-focused': {
            color: '#3f51b5'
          }
        }
      }
    }
  }
});

// 抽取内容组件
const ContentSection = ({ title, items }) => (
  <>
    <div
      style={{
        margin: 0,
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
        lineHeight: 1.5,
        letterSpacing: '0.00938em',
        color: '#4b4b4b',
        fontSize: '21.25px',
        fontWeight: 600
      }}>
      {title}
    </div>
    <div
      style={{
        margin: 0,
        lineHeight: 1.5,
        letterSpacing: '0.00938em',
        textAlign: 'left',
        color: '#888888',
        fontSize: '17px',
        fontFamily: 'PingFang SC',
        fontWeight: 600,
        marginBottom: '24px'
      }}>
      <ul
        style={{
          display: 'block',
          listStyleType: 'disc',
          marginBlockStart: '1em',
          marginBlockEnd: '1em',
          paddingInlineStart: '40px',
          unicodeBidi: 'isolate'
        }}>
        {items.map((item, index) => (
          <li
            key={index}
            style={{
              display: 'list-item',
              textAlign: '-webkit-match-parent',
              unicodeBidi: 'isolate'
            }}>
            {item}
          </li>
        ))}
      </ul>
    </div>
  </>
);

const Drivers = () => {
  const [region, setRegion] = useState('');
  const [regions, setRegions] = useState([]);
  const [open, setOpen] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const openLinkRef = useRef(null);

  const handleRegionChange = event => {
    setRegion(event.target.value);
  };

  const handleSubmit = event => {
    event.preventDefault();
    if (!region) {
      setOpen('region');
      return;
    }
    // 检查是否有对应的链接
    const regionConfig = regions.find(r => r.id === region);
    if (regionConfig && regionConfig.applicationLink) {
      // 有对应链接，进行跳转
      openLinkRef.current = regionConfig.applicationLink;
      setOpenConfirm(true);
    } else {
      // 没有对应链接，显示维护提示
      setOpenDialog(true);
    }
  };

  const handleClose = () => {
    setOpen('');
  };

  useEffect(() => {
    const getRecruitmentInfo = async () => {
      const res = await getRecruitmentInfoList();
      if (res?.result) {
        setRegions(res?.object);
      }
    };
    getRecruitmentInfo();
  }, []);

  // 内容数据
  const contentData = {
    profile: {
      title: 'Creating a Driver Profile',
      items: [
        "It's simple; answer the two questions below and Weee! will automatically direct you to our driving platform, where you can submit your details to become a delivery driver for Grocery Deliveries. "
      ]
    },
    whatWeWant: {
      title: 'What we want you to do',
      items: [
        'Pick up orders from our local hub and safely load them into your personal vehicle.',
        'Deliver and unload the correct orders to delivery locations in a professional and safe manner.',
        'Always follow designated sanitation and safety guidelines.'
      ]
    },
    whatWeNeed: {
      title: 'What we need from you',
      items: ['You must own and drive a personal Minivan, Delivery Van, or Large SUV for grocery deliveries.']
    },
    requirements: {
      title: 'Requirements',
      items: [
        'Must be over 21 years of age',
        'Have 6 months minimum of previous delivery driver experience',
        "A valid driver's license",
        'Proof of auto insurance',
        'Authorization to work for any US Employer',
        'Clear background and MVR record',
        'Ability to read a map or use GPS directions',
        'Able to lift 50 lbs',
        'A great attitude with even better customer service skills'
      ]
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={open !== ''}
        autoHideDuration={6000}
        onClose={handleClose}>
        <Alert variant="filled" severity="error">
          missing {open}
        </Alert>
      </Snackbar>
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle className="text-center">Maintenance</DialogTitle>
        <div className="px-6 pt-4 pb-6">
          <Alert variant="filled" severity="warning">
            Our application page is currently undergoing maintenance. In the meantime, please email us at
            driverhiring@sayweee.com with your name, contact info, and city of interest. We'll get back to you shortly!
          </Alert>
        </div>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
          <Button
            color="info"
            onClick={() => {
              location.href =
                'https://us-2.fountain.com/weee/apply/jacksonville-fl-independent-contractors-delivery-driver-1099';
              setOpenDialog(false);
            }}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openConfirm} onClose={() => setOpenDialog(false)}>
        <div
          style={{
            fontSize: '1rem',
            fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
            fontWeight: 400,
            lineHeight: '1.5',
            letterSpacing: '0.00938em',
            color: 'rgba(0, 0, 0, 0.54)'
          }}
          className="mb-3 pt-5 px-6">
          You will be directed to Fountain to complete the application.
        </div>
        <DialogActions>
          <Button sx={{ color: 'rgba(0, 0, 0, 0.87)' }} onClick={() => setOpenConfirm(false)}>
            Cancel
          </Button>
          <Button
            onClick={e => {
              location.href = openLinkRef.current;
            }}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      <div>
        <div
          style={{
            boxShadow:
              '0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)'
          }}
          className="bg-[#3f51b5] text-white sticky w-full h-[56px] px-4 box-border flex items-center">
          <img src={imgLogo} alt="logo" className="w-[90px]" />
        </div>
        <div className="text-[#4b4b4b] text-[41.5px] my-8 font-semibold leading-150 text-center">
          <span>Delivery Driver</span>
        </div>
        <div
          style={{
            color: 'rgba(0, 0, 0, 0.87)',
            boxShadow:
              '0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)'
          }}
          className="p-10 my-[4%] mx-[5%] rounded-200">
          <div>
            <p
              style={{
                margin: 0,
                lineHeight: 1.5,
                letterSpacing: '0.00938em',
                textAlign: 'center',
                color: '#888888',
                fontSize: '17px',
                fontFamily: 'PingFang SC',
                fontWeight: 600,
                marginBottom: '24px'
              }}>
              Thank you for applying as a Delivery Driver for Weee! You'll be driving as an Independent or Flex
              Contractor.
            </p>
            <ContentSection {...contentData.profile} />
            <ContentSection {...contentData.whatWeWant} />
            <ContentSection {...contentData.whatWeNeed} />
            <ContentSection {...contentData.requirements} />
          </div>
          {/* form */}
          <form onSubmit={handleSubmit} className="px-10 mt-16 max-w-[444px] mx-auto">
            <FormControl fullWidth>
              <InputLabel id="region-label">Region</InputLabel>
              <Select onChange={handleRegionChange} labelId="region-label" label="Region">
                {regions.map(region => (
                  <MenuItem key={region?.id} value={region?.id}>
                    {region?.locationName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <button
              style={{
                border: 0,
                cursor: 'pointer',
                display: 'inline-flex',
                outline: 0,
                position: 'relative',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '6px 16px',
                fontSize: '0.875rem',
                minWidth: '64px',
                boxSizing: 'border-box',
                fontWeight: 500,
                lineHeight: 1.75,
                borderRadius: 4,
                textTransform: 'uppercase',
                boxShadow:
                  '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
                color: '#fff',
                backgroundColor: '#3f51b5',
                width: '100%',
                margin: '10px 0px 16px'
              }}
              type="submit">
              <span className="MuiButton-label">Continue</span>
            </button>
          </form>
        </div>

        {/* footer */}
        <div
          style={{
            color: `rgba(0, 0, 0, 0.54)`
          }}
          className="mt-[64px] pb-10 text-center">
          <p className="footer">
            Copyright ©{' '}
            <a style={{ color: `rgba(0, 0, 0, 0.54)` }} href="https://sayweee.com/" target="_top">
              <u>Weee! Inc</u>
            </a>{' '}
            {new Date().getFullYear()}.
          </p>
        </div>
      </div>
    </ThemeProvider>
  );
};

export default Drivers;

 const _getStaticProps = async ctx => {
  return {
    props: {
      containerClassName: 'drivers'
    }
  };
};


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/drivers/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  